export default __webpack_public_path__ + "locales/sl/EmptyTrashDialog.json?hash=5053e37d149a43c569527c462877329b";